module.exports = __webpack_public_path__ + "catalog/items/firesafety/Smoke-Detector-V2/Smoke-Detector-V2.svg";